<script setup>
const SIZE_PX = { small: 20, medium: 40, large: 60 }

defineProps({
    size: {
        type: String,
        default: 'medium',
        validator: value => ['small', 'medium', 'large'].includes(value),
    },
})
</script>

<template>
    <div
        class="spinner-container"
        role="status"
        aria-label="Loading"
    >
        <svg
            class="spinner spin"
            :width="SIZE_PX[size]"
            :height="SIZE_PX[size]"
        >
            <use href="#icon-spinner" />
        </svg>
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.spinner-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
}

.spinner {
    color: $c-accent-default;
    // The builder strips stroke-width from symbols; BaseIcon's scoped rule
    // reinstates it for `.icon`, but this raw svg is not one — without this the
    // vinyl strokes fall back to the SVG default 1px hairline.
    stroke-width: 1.5;
}
</style>
